// extracted by mini-css-extract-plugin
module.exports = {"root":"Business_root__3a9lP","store":"Business_store__LH4wN","company":"Business_company__3iTQ3","separator":"Business_separator__1vC5j"};